import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { Badge } from '@fhs/ui';
import { tokens } from '@fhs/ui';

interface Props {
  currentStep: number;
  totalSteps: number;
  style?: StyleProp<ViewStyle>;
}

export function StepsProgress({ currentStep, totalSteps, style }: Props) {
  const isCompleted = (step: number) => step < currentStep;
  return (
    <View style={[styles.container, style]}>
      {Array.from({ length: totalSteps }).map((_, index) => (
        <>
          <Badge
            circular
            color={isCompleted(index) ? tokens.colors.$success : tokens.colors.$black10}
            textColor={isCompleted(index) ? tokens.colors.$white : tokens.colors.$placeholderText}
          >
            {index + 1}
          </Badge>
          {index < totalSteps - 1 && (
            <View
              style={[
                styles.separator,
                {
                  backgroundColor: isCompleted(index + 1)
                    ? tokens.colors.$success
                    : tokens.colors.$black10,
                },
              ]}
            />
          )}
        </>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  separator: {
    flex: 1,
    height: 2,
    marginHorizontal: 4,
  },
});
